import React from 'react';
import Markdown from 'react-markdown';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import remarkGfm from "remark-gfm";

const BlockquoteRenderer = props => {
    return(
        <>
            {
                props.children.map((child, i) => (
                    <div key={i}>
                        <strong>
                            <FontAwesomeIcon icon={faInfoCircle} />&nbsp;
                            <span>{child.props.children[0].props.children} ll</span>
                        </strong>
                    </div>
                ))
            }
            <style jsx>{`
                div {
                    color: #0084a9;
                }
            `}</style>
        </>
    );
};

const LinkRenderer = props => {
    return <a href={props.href} target="_blank" rel="noopener noreferrer">{props.children}</a>;
};

export default function UiMarkdown(props) {
    const { source, newProps } = extractDeprecatedSourceProp(props);
    return (
        <Markdown
            {...newProps}
            components={{
                blockquote: BlockquoteRenderer,
                a: LinkRenderer
            }}
            remarkPlugins={[remarkGfm]}
        >
            {props.children ?? source}
        </Markdown>
    );
}

/*
Using a source prop is deprecated in react-markdown. Instead the content should be injected as children.
This function ensures backwards compatibility for our code and removes custom props that shouldn't
be passed to the Markdown component.
*/
function extractDeprecatedSourceProp(originalProps) {
    const newProps = {...originalProps};
    const source = newProps.source ?? null;

    // Remove deprecated and custom props that shouldn't be passed to Markdown
    delete newProps.source;
    delete newProps.skipHtml;
    delete newProps.children;

    return {source, newProps};
}

